import {
  getSimpleSpuReq,
  getSimpleSkuReq,
  getDetailSpuReq,
  getDetailSkuReq,
  getInstallmentReq,
  getRecommendReq,
  getAIRecommend,
  listMemberFavorite,
  getPointInfoReq,
  getEstimatedPrice,
  getRemarkList,
  getPartCmmdyList,
  shareContent,
  getAdditionRecommend
} from './api'
import buySubmodule from './buy-submodule'
import recycle from './recycle'
import env from '@/utils/clientEnv'
import app from '@/utils/app'
import { getCookie, toggleClickable, getParameter, getMachineCode } from '@/utils/common'
import { hideSiblingEls, setAriaLiveByIds } from '@/utils/aria'
import { isDarkColor, formatNumber } from 'utils/common'
import { getAIData } from '@/utils/ai'
import { vipFirstBuyPopup } from '@/components'
import { init as skuInit, update as spuUpdate } from '@/views/product/detail/components/sku-select/sku'
export default {
  namespaced: true,
  state: {
    ...recycle.state,
    // 弹层打开时聚焦的元素
    preFocusEl: [],
    // 弹层打开需要隐藏自动播报的元素id
    ariaLiveElIds: ['product-info-title', 'price-module'],
    // page参数
    pageInit: false,
    // 首屏和异步接口都返回了
    pageAllInit: false,
    pageError: false,
    // 首屏SKU缓存数据
    allSkuSimpleData: {},
    // 异步SKU缓存数据
    allSkuDetailData: {},
    // 首屏SKU缓存数据-移动特惠
    allSkuSimpleDataForYD: {},
    // 异步SKU缓存数据-移动特惠
    allSkuDetailDataForYD: {},
    // 所有分期数据缓存
    allInstallmentData: {},
    // 页面数据
    // spu信息，添加默认参数，解决页面抖动问题
    spuInfo: null,
    // sku信息
    skuInfo: {
      specImgUrl: 'https://shopstatic.vivo.com.cn/vivoshop/commodity/spec/59/10007159_1639985144847_3451x225.jpg.webp'
    },
    // 当前时间 - 用于预热展示等
    skuCurrentTime: 0,
    skuCurrentTimeDistance: 0,
    specInfo:{},
    // 分期信息
    installment: {},
    // 已选参数
    selectParams: {
      // 名称
      name: '',
      // 数量
      number: 1,
      // 分期
      fqNum: 0,
      // 镭雕
      laser: false,
      // 套餐
      currentSuite: {},
      // 服务
      service: {},
      // 加购商品信息
      additionCommodity: [],
      // 购买方式
      buyType: 1,
      // 正在提交中
      isSubmiting: false
    },
    // 加购推荐商品
    additionRecommendList: [],
    recommendMap: {},
    // 推荐商品
    recommendList: [],
    // 已经收藏的skuid集合
    collectedSkuIds: [],
    // 是否含有评价信息，用于判断是否需要显示titlebar、评价气泡
    postPreviews: null,
    // 判断视频是否可以播放，主要用于弹层的时候需要暂停，关闭的时候需要重新播放
    isVideoCanPlay: true,
    // 控制是否显示sku选择弹层
    isShowSkuSelect: false,
    // 打开sku弹层时需要传递的参数
    skuSelectParams: {},
    // 快速参团信息
    quickGrouponInfo: '',
    // 快速参团模块是否可见
    quickGrouponVisibility: true,
    // 优惠券弹窗
    discountPopupStatus: false,
    // 分期付款弹窗
    installmentPopupStatus: false,
    // 积分弹窗
    pointDescriptionPopupStatus: false,
    // 加购成功弹窗
    shopcartPopupStatus: false,
    // 加购成功后保存cartId
    cartIdValue: null,
    cartNumber: 0,
    installmentInit: false,
    addressId: null,
    // 当前skuId下选择的可选赠品id参数
    giftIds: '',
    // 是否点击过赠品行, 1是点击过了
    giftOpt: 0,
    // 每个skuId商品对应主动勾选的可选赠品
    selectedGifts: [],
    // 最后一次主动勾选的赠品
    lastChoosedGiftIds: '',
    logisticsMsg: '',
    // 经度
    longitude: '',
    // 纬度
    latitude: '',
    // 所选地区是否在地址库中，-1未判断,1在，0不在
    addressNewFlag: -1,
    // 现货购买到手价
    spotEstimatedPrice: null,
    // 支持会员先享购下单结算
    vipFirstBuyDisable: false,
    spuQuery: null, // 离屏渲染存储真实url参数，方便组件提取参数
    // 评价信息
    remarkInfo: null,
    // 原装配件适用说明弹层是否展示
    adpatedPopupShow: false,
    addCartParams: null, // 加购参数
    // 原装配件列表弹层是否展示
    partListPopupShow: false,
    partAdaptedObject: {
      flag: false,
      list: []
    },
    isAPPTemplate: 0, // 是否离屏模型模式
    templateDataType: 0, // 1离屏渲染 1-1返回首屏，1-2返回部分数据
    isRegulate: false, // 离屏渲染价格校正
    clickTime: new Date().getTime(), // 点击商品的当前时间
    initDuration: 0, // 离屏渲染点击到初始化的时长
    firstScreenDuration: 0, // 首屏绘制时长（LCP）
    skuShareInfoStore: {},
    skuContractShareInfoStore: {}, // 选择移动用户特惠时的分享信息
    // 所选地址信息
    addressData: null,
    // 是否开始渲染送至和门店闪送模块
    showAddressFlag: false,
    // 自动分享弹层
    autoShareFlag: false,
    videoInitFlag: false,
    // 是否获取到坐标，走lbs门店查询逻辑
    isLBS: false,
    // 控制是否显示以旧换新iframe弹层
    isShowRecycleIframe: false,
    recycleIframeParams: {},
    // 加购商品信息
    additionCommodityInfo: [],
    // 商详页和选购弹层展示的加购商品信息
    showAdditCommInfo: [],
    // 加购模块展示位置AB实验（0：【评价&问答】下方  1：【评价&问答】上方）
    additionLocation: 0,
    // 历史加购商品选择信息,用于回显，格式实例{spuList:[],skuList:[]}
    preSelectedAdditionCommodity: { spuList: [], skuList: [] },
    isShowRemarkPopup: false, // 评价列表页是否展示
    // 用户缓存地址，用于初始化请求以旧换新分流
    cacheAddressData: '',
    // 加购-弹层商品图位置
    cartAnimPosition: {}
  },
  getters: {
    ...buySubmodule.getters,
    ...recycle.getters,
    productQuery: (state, getters, { route }) => {
      return state.spuQuery || route.query
    },
    timestamp: (state, getters, { route }) => {
      return route.query.timestamp
    },
    spuId: (state, getters, { route }) => {
      return state.spuInfo?.commoditySpu?.id || route.params.spuId
    },
    skuId: (state, getters, { route }) => {
      return state.skuInfo?.commoditySkuBaseInfo?.skuId || route.query.skuId || route.query.colorSkuid
    },
    partAdaptedInfo: (state, getters) => {
      // 原装配件功能A/B处理
      if (!state.skuInfo?.partAdaptedGrayTestVo?.adaptedShow) {
        return {}
      }
      return state.skuInfo?.partAdaptedToModelVo || {}
    },
    showPartAdapted: (state, getters) => {
      // 原装配件功能A/B处理
      if (!state.skuInfo?.partAdaptedGrayTestVo?.adaptedShow) {
        return false
      }
      return [1, 2, 4].indexOf(getters.partAdaptedInfo?.partAdaptedToModelType) > -1
    },
    isShieldPartActivity: (state, getters) => {
      // 【商详页屏蔽配件的活动】一分团、会员先享购
      return getters.isLottery || getters.isVipFirstBuy
    },
    skuCode: (state, getters, { route }) => {
      return state.skuInfo?.commoditySkuBaseInfo?.skuCode
    },
    remarkInfo(state) {
      return state.remarkInfo
    },
    // 该spu下的sku数量
    skuNum(state) {
      return state.spuInfo?.specItem.skuSpecList.length
    },
    // 优惠类型 vip,group,deposit,fullpay,quickbuy,bigpromotion,normal,quickbuypreheat, quickbuycustomatmos
    // 分别对应 会员,拼团,定金,全款,抢购,大促礼盒,正常,抢购预热,抢购带自定义背景
    discountType: (state, getters) => {
      let discountType = state.skuInfo?.commoditySkuDiscount?.commodityDiscountType || 'normal'
      if (
        discountType === 'quickbuy' &&
        state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuy?.isAtmosphere === 0
      ) {
        if (
          state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuy?.atmosphereInfo
            ?.backgroundPic
        ) {
          discountType = 'quickbuycustomatmos'
        } else {
          discountType = 'quickbuynoatmos'
        }
      }
      return discountType
    },
    commodityLive: state => {
      return state.spuInfo?.commodityLive || {}
    },
    // 商品状态异常编码【1：已售罄 2：立即预约 3：到货通知 4：下架】
    extCode(state, getters) {
      // 移动特惠时，判断移动特惠商品库存[如果活动库存不足且常规商品处于售罄或到货通知状态]
      const code = state.skuInfo?.commoditySkuButton?.commodityExceptionCode
      if(getters.isOperatorBuyType && (code == 1 || code == 3)){
        const contractPhoneTips = state.skuInfo?.commoditySkuDiscount?.contractPhoneTips
        const noContractPhone = contractPhoneTips || !state.skuInfo?.commoditySkuDiscount?.commodityEstimated?.contractPhoneAct
        return  noContractPhone ? 1 : 0
      }
      return state.skuInfo?.commoditySkuButton?.commodityExceptionCode
    },
    // 预约id
    appointId(state) {
      return state.skuInfo?.commoditySkuButton?.appointId
    },
    // 是否是查看相似商品，当下架或无库存，但是有推荐时
    isSeeOther(state, getters) {
      return (getters.extCode == 1 || getters.extCode == 4 || getters.isGift) && getters.hasRecommend
    },
    // 正常商品，非活动状态
    isNormal(state, getters) {
      return getters.discountType === 'normal'
    },
    // 是否为拼购
    isGroup(state, getters) {
      return getters.discountType === 'group'
    },
    // 是否是简单拼团（没有服务，且该spu下只有一个sku）
    isSimpleGroup(state, getters) {
      return getters.isGroup && getters.skuNum == 1 && !state.spuInfo?.commoditySvcs?.length
    },
    // 是否为一分团
    isLottery(state, getters) {
      return (
        getters.isGroup &&
        state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.grouponType == 1
      )
    },
    // 是否为抢购
    isQuickBuy(state, getters) {
      return getters.discountType === 'quickbuy'
    },
    // 是否为会员优先购
    isVipFirstBuy(state, getters) {
      return getters.discountType === 'vip'
    },
    // 会员先享购信息
    commodityVipFirst(state) {
      return state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst
    },
    // 赠品
    commodityGifts(state) {
      return state.skuInfo?.commoditySkuDiscount?.commodityGifts || []
    },
    //是否为定金预售
    isDepositBuy(state, getters) {
      return getters.discountType === 'deposit'
    },
    //定金预售信息
    commodityDeposite(state) {
      return state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite
    },
    // 定金预售是否支持现货购买
    isSpot(state, getters) {
      return getters.discountType === 'deposit' && getters.commodityDeposite?.spotStatus
    },
    //是否为全款预定
    isFullPayBuy(state, getters) {
      return getters.discountType === 'fullpay'
    },
    //全款预定信息
    commodityFullPay(state, getters) {
      return state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityFullPay
    },
    // 是否预热状态会员先享购
    isPreTimeVip(state, getters) {
      return getters.isVipFirstBuy && getters.commodityVipFirst && getters.commodityVipFirst.state === 2
    },
    // 是否是大促
    isBigpromotion(state, getters) {
      return getters.discountType === 'bigpromotion'
    },
    //v码购商品信息
    vCodeInfo(state){
      return state.skuInfo?.commoditySkuDiscount?.vCodeInfo
    },
    // 大促礼盒干预信息
    commodityBigPromotion(state) {
      return state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityBigPromotion
    },
    // 活动logo干预
    interventureLogoPic(state) {
      return state.skuInfo?.commoditySkuDiscount?.interventureLogoPic
    },
    // 是否为有氛围抢购
    isAtmosphere(state, getters) {
      return (
        getters.isQuickBuy &&
        state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuy?.isAtmosphere
      )
    },
    // 自定义氛围抢购无背景
    isNoAtmosphere(state, getters) {
      return getters.discountType == 'quickbuynoatmos'
    },
    // 自定义氛围带背景
    hasCustomAtmosphereBg(state, getters) {
      return getters.discountType == 'quickbuycustomatmos'
    },
    // 是否为自定义氛围抢购
    isCustomAtmosphere(state, getters) {
      return getters.isNoAtmosphere || getters.hasCustomAtmosphereBg
    },
    // 自定义氛围配置信息
    customAtmosphereInfo(state, getters) {
      if (!getters.isCustomAtmosphere) return null
      return state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuy?.atmosphereInfo
    },
    // 是否展示促销模块
    isShowPromotion(state, getters) {
      const { isQuickBuy, isAtmosphere, discountType } = getters
      if (isQuickBuy) {
        // 无氛围抢购不显示
        return isAtmosphere
      } else {
        // 正常和抢购预热是没有促销模块的，当做正常商品来显示
        return !(discountType === 'normal' || discountType === 'quickbuypreheat')
      }
    },
    isNoAtmospherePromotion(state, getters) {
      return (
        getters.isNoAtmosphere && state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityBigPromotion
      )
    },
    // 优惠模块是否展示判断
    isShowDiscount(state, getters) {
      return getters.isAtmosphere || getters.isGroup || getters.isBigpromotion
    },
    isShowDiscountComponent(state, getters) {
      return getters.stagingInfo || getters.fullDiscount?.length || getters.couponDescs?.length
    },
    // 判断是否在大促仅有分期
    isShowStagingInfo(state, getters) {
      // return getters.stagingInfo?.length && !getters.fullDiscount?.length && !getters.couponDescs?.length
      // 存在分期信息且销售价不为999999时
      return Boolean(getters.stagingInfo?.length && state.skuInfo.commoditySkuBaseInfo.salePrice !== 999999)
    },
    // 分期信息
    stagingInfo: state => {
      if (state.installment?.optimal) {
        const type = state.installment?.detail?.hbInstallment ? '花呗' : '丰融分期'
        return `${type}${state.installment.optimal.num}期${
          state.installment.optimal.userPerFeePay ? '分期' : '免息'
        }，每期仅需<span style="color: ${app.getColorScheme() ? '#d90311' : '#f10313'};">${
          state.installment.optimal.perPay
        }</span>元`
      }
      //判断是否存在银联分期
      if (state.installment?.detail?.unionPayInstallment?.bankInstallmentList) {
        return '可使用银联信用卡分期购买'
      }
    },
    // 满减信息
    fullDiscount: state => {
      let DiscoutnAct = state.skuInfo?.commoditySkuDiscount?.commodityOrderMyjyAct
      let fullDiscountArr = []
      if (DiscoutnAct?.actBounsBasePrice && DiscoutnAct?.actBounsPrice) {
        fullDiscountArr.push({
          actBounsTitle: `限时满${DiscoutnAct.actBounsBasePrice}元减${DiscoutnAct.actBounsPrice}元`,
          actBounsTime: DiscoutnAct.actBounsDesc
        })
      }
      return fullDiscountArr
    },
    // 优惠券信息
    couponDescs: state => {
      return state.skuInfo?.couponDescs
    },
    // 预计到手价
    commodityEstimated: (state, getters) => {
      // 灰度判断 && 如果有套餐也不显示到手价
      let estimated = !getters.currentSuiteInfo?.id
        ? state.skuInfo?.commoditySkuDiscount?.commodityEstimated || null
        : null
      return (
        estimated &&
        Object.assign({}, estimated, {
          couponMemberLevel: {
            0: 'new', // 新人价
            1: 'common',
            2: 'silver', // 白银
            3: 'gold'
          }[estimated.couponMemberLevel]
        })
      )
    },
    // 价格显示，用于基础价格，促销活动等地方
    mainPrice: (state, getters) => {
      // 套餐价格，除了套餐外都用commodityDiscountPrice
      if (state.selectParams.currentSuite?.id  && !getters.isOperatorBuyType) { // 移动特惠不计算套餐价格，考虑上次记录
        return state.selectParams?.currentSuite?.totalPrice
      } else if (state.skuSelectParams.source === 8) {
        return state.skuInfo.commoditySkuBaseInfo.salePrice
      } else {
        return state.skuInfo?.commoditySkuDiscount?.commodityDiscountPrice
      }
    },
    delPrice: (state, getters) => {
      const { isGroup, isLottery } = getters
      if (state.selectParams.currentSuite?.id  && !getters.isOperatorBuyType) { // 移动特惠不计算套餐价格，考虑上次记录
        return state.selectParams.currentSuite.totalPrice + state.selectParams.currentSuite.discountAmount
      } else if (isGroup || isLottery) {
        return state.skuInfo.commoditySkuBaseInfo.salePrice
      } else {
        return state.skuInfo.commoditySkuBaseInfo.marketPrice
      }
    },
    // 根据选中计算的总价格
    totalPrice: (state, getters) => {
      let { mainPrice, totalServicePrice } = getters
      // 加上服务的价格和加购商品价格
      return formatNumber(
        (mainPrice + totalServicePrice) * state.selectParams.number + getters.totalAdditionCommodityActivityPrice
      )
    },
    totalServicePrice(state, getters) {
      let price = 0
      // 移动特惠不计算服务价格，考虑购买方式上次选择保留记录
      if(!getters.isOperatorBuyType){
        Object.values(state.selectParams.service || {}).forEach(item => {
          if (item && item.salePrice) {
            price += Number(item.salePrice)
          }
        })
      }
      return formatNumber(price)
    },
    // 加购商品总售价
    totalAdditionCommodityActivityPrice(state, getters) {
      let price = 0
      // 移动特惠不计加购商品总售价，考虑购买方式上次选择保留记录
      if(!getters.isOperatorBuyType){
        state.selectParams.additionCommodity.forEach(item => {
          if (item && item.activityPrice) {
            price += Number(item.activityPrice)
          }
        })
      }
      return formatNumber(price)
    },
    // 加购商品总市场价
    totalAdditionCommoditySalePrice(state, getters) {
      let price = 0
      // 移动特惠不计加购商品总售价，考虑购买方式上次选择保留记录
      if(!getters.isOperatorBuyType){
        state.selectParams.additionCommodity.forEach(item => {
          if (item && item.salePrice) {
            price += Number(item.salePrice)
          }
        })
      }
      return formatNumber(price)
    },
    // 是否有加购商品
    hasAdditionCommodity(state) {
      return state.selectParams.additionCommodity.length > 0
    },
    // 是否需要加购动画
    // 如果用户加入购物车，没有加价购商品，没有推荐，那就展示抛物线动画+toast提示
    // 如果用户加入购物车，有加价购商品或者有推荐商品，那就直接展示加价购弹层 + GIF图那个效果
    isNeedAddCartAnim(state, getters){
      return getters.hasAdditionCommodity || (!getters.hasAdditionRecommendList && !getters.hasAdditionList)
    },
    depositTotalPrice(state, getters) {
      let { totalServicePrice } = getters
      let price
      if (state.selectParams.currentSuite?.id && !getters.isOperatorBuyType) { // 移动特惠不计加购套餐价格
        let depositAmountValue =
          state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.depositSwellAmount ||
          state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.depositAmount ||
          0
        price = Number(state.selectParams?.currentSuite?.totalPrice) - Number(depositAmountValue)
      } else {
        price =
          state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite
            ?.tailAmountExcludeSwellAmount
      }
      return (Number(price) + totalServicePrice) * state.selectParams.number
    },
    /**
     * 获取商品类型, 商品类型，1：手机 2：配件 3：服务宝商品 4：虚拟商品
     */
    goodsType(state) {
      return state.spuInfo?.commoditySpu?.cmmdyTypeId
    },

    /**
     * 判断当前是否是套餐，且有套餐图片
     */
    hasSuiteImages(state, getters) {
      return getters.currentSuiteInfo?.imageInfos?.length
    },
    /**
     * 渐变色
     */
    color(state, getters) {
      let colorName = state.skuInfo?.commoditySkuBaseInfo?.colorName
      // 手机、且非活动状态，且后台开启渐变，且非套餐状态
      // update：v9.5.0活动状态也显示渐变色
      if (state.isAPPTemplate && state.skuInfo?.specItemColor) {
        // 离屏渲染预拉背景色
        return {
          value: state.skuInfo?.specItemColor?.value,
          valueExt: state.skuInfo?.specItemColor?.valueExt
        }
      } else if (state.spuInfo?.themeShowFlag === 1 && colorName && getters.isPhone && !getters.hasSuiteImages) {
        let colorList = state.spuInfo?.specItem?.specItemSeq?.[1]
        if (colorList) {
          let color = colorList.find(item => {
            return item.name == colorName
          })
          if (color) {
            return color
          } else {
            return {
              value: '#ffffff',
              valueExt: '#ffffff'
            }
          }
        }
      }
      return {
        value: '#ffffff',
        valueExt: '#ffffff'
      }
    },

    /**
     * 判断深浅颜色，设置不同的值
     */
    isDarkColor(state, getters) {
      return isDarkColor([getters.color.value, getters.color.valueExt])
    },

    /**
     * 图片预览背景色
     */
    bannerStyle(state, getters) {
      return {
        backgroundColor: getters.color?.value,
        backgroundImage: `linear-gradient(to bottom right, ${getters.color.value} 0%, ${getters.color.valueExt} 100%)`
      }
    },

    /**
     * 是否仅作为赠品
     */
    isGift(state) {
      return state.spuInfo?.commoditySpu?.giftSign == 1
    },
    /**
     * 判断是否为手机类型
     */
    isPhone(state, getters) {
      return getters.goodsType === 1
    },
    /**
     * 判断是否为配件类型
     */
    isAccessory(state, getters) {
      return getters.goodsType === 2
    },
    /**
     * 判断是否为服务宝商品，服务宝商品后续计划纳入虚拟商品购买流程，根据交互决定是否可将虚拟商品以及服务宝商品判断合并-nhf
     */
    isServiceGoods(state, getters) {
      return state.spuInfo?.commoditySpu?.cmmdyTypeId == 3
    },
    /**
     * 是否为虚拟商品类型
     */
    isVirtualGoods(state){
      return state.spuInfo?.commoditySpu?.cmmdyTypeId == 4
    },
    // 是否为售后服务商品  virtualType:2-售后服务商品 3-权益商品 4-卡密商品 5-优惠券商品 1是v粉卡(已弃用);
    isAftServiceGoods(state,getters){
      return getters.isVirtualGoods  && state.spuInfo?.commoditySpu?.virtualType == 2
    },
    /**
     * 是否为v码购
     */
    isVNumGoods(state,getters){
      return getters.vCodeInfo?.vCodeBuy
    },
    /**
     * 是否版本外显
     */
    showOuterSwitch(state, getters) {
      // 代销商品或拼团活动商品不显示版本外显
      if (getters.discountType === 'group' || getters.isProxySale) return false

      if (getters.goodsType == 1) {
        return true
      } else if (getters.goodsType == 2) {
        // 如果为配件，判断规格项是否不超过两个，超过两个规格项则不展示外显
        return state.spuInfo?.specItem?.specMain?.length <= 2
      }
    },
    /**
     * 是否展示外显颜色组件
     */
    showOuterColor(state, getters) {
      // 如果不显示版本外显，则不显示颜色外显组件
      if (!getters.showOuterSwitch) return false

      // 手机和配件
      if (getters.goodsType == 1 || getters.goodsType == 2) {
        let colors = []
        const specMain = state.spuInfo?.specItem?.specMain
        const specItemSeq = state.spuInfo?.specItem?.specItemSeq
        const specMainSeq = state.spuInfo?.specItem?.specMainSeq
        // 有版本外显
        if (getters.showOuterVersion) {
          if (getters.goodsType == 1) {
            // 如果为手机，则显示颜色外显组件
            return true
          } else if (getters.goodsType == 2) {
            // 如果是配件，则判断是否有颜色这个规格项（规格项数目在showOuterSwitch中已经判断，无需再判断）
            const specNameMap = state.spuInfo?.specItem?.specMainSeq
            return !!specNameMap && Object.values(specNameMap).some(item => item === '颜色')
          }
          // 没有版本外显
        } else {
          let index
          for (const key in specMainSeq) {
            if (specMainSeq[key] === '颜色') {
              index = key
            }
          }
          if (index === undefined) {
            return false
          } else {
            colors = specItemSeq[index]
            // 规格数量大于1展示，否则不展示
            return colors.length > 1
          }
        }
      } else {
        // 非手机和配件，不展示
        return false
      }
    },
    /**
     * 是否显示外显版本组件
     */
    showOuterVersion(state, getters) {
      // 如果不显示版本外显，则不显示颜色外显组件
      if (!getters.showOuterSwitch) return false

      // 以下讨论显示版本外显的情况，即showOuterSwitch为true的情况
      let versions = null
      const specMain = state.spuInfo?.specItem?.specMain
      const specItemSeq = state.spuInfo?.specItem?.specItemSeq
      const specMainSeq = state.spuInfo?.specItem?.specMainSeq
      if (getters.goodsType == 1) {
        // 如果为手机，则只要版本规格大于1，就显示
        versions = specItemSeq[specMain[0]]
      } else if (getters.goodsType == 2) {
        // 如果是配件，则判断规格数量
        const specNum = specMain.length
        if (specNum == 1) {
          // 如果只有1个规格，判断其是否为颜色(优先显示颜色)：如果不是颜色，将规格值数组赋值给versions
          if (specMainSeq[specMain[0]] !== '颜色') {
            versions = specItemSeq[specMain[0]]
          }
        } else if (specNum == 2) {
          // 如果有两个规格，则必须有一个规格为颜色才显示
          const specNameMap = state.spuInfo?.specItem?.specMainSeq
          const hasColor = Object.values(specNameMap).some(item => item === '颜色')
          if (hasColor) {
            const colorSpecIdIndex = Object.entries(specMainSeq)?.findIndex(item => {
              return item[1] !== '颜色'
            })
            let versionIndex = colorSpecIdIndex ? 0 : 1
            versions = specItemSeq[specMain[versionIndex]]
          }
        }
      }

      // 其他商品类型默认不展示颜色外显组件
      return versions?.length > 1
    },
    /**
     * 是否存你可能还喜欢商品
     */
    hasRecommend(state) {
      return state.skuInfo?.commoditySkuButton?.hasRecommend
    },
    /**
     * 是否存评价
     */
    hasEvaluation(state) {
      return !!state.postPreviews?.commentDetailsPage?.list?.length
    },
    /**
     * 是否为严选商品
     */
    isYX(state) {
      return state.spuInfo?.commoditySpu?.platformCode == '100001'
    },
    /**
     * 是否为代销商品
     */
    isProxySale(state) {
      return state.spuInfo?.commoditySpu?.proxySale == 1
    },
    /**
     * 获取当前套餐信息
     */
    currentSuiteInfo(state, getters) {
      // 移动特惠与套餐互斥，为保留立即购买下的套餐选中状态，此处直接返回套餐空
      if(getters.isOperatorBuyType) return {}
      return state?.selectParams?.currentSuite
    },
    /**
     * 是否是移动特惠购买方式
     */
    isOperatorBuyType(state,getters){
      return getters.isVNumGoods ? false : state?.selectParams?.buyType == 3
    },
    // 移动特惠且商品待发布
    isContractPhoneAndUnpublish(state, getters){
      return getters.isOperatorBuyType && state.skuInfo.commoditySkuBaseInfo.salePrice === 999999
    },
    operatorAct(state, getters){
      const acts = state.spuInfo?.contractPhoneInfoVo?.skuActs || []
      return acts.find(item => item.skuId == getters.skuId)
    },
    // 花呗分期悬浮提示
    antInstallmentTips(state) {
      // 正常文案
      let comArray = []
      // 免息文案
      let freeArray = []
      if (state?.installment?.detail?.hbInstallment?.perInstallmentInfoList) {
        let tempInstallment = state?.installment?.detail?.hbInstallment?.perInstallmentInfoList
        for (let i = 0; i < tempInstallment.length; i++) {
          if (tempInstallment[i].userPerFeePay) {
            // 含有分期利息
            comArray.push(tempInstallment[i].num)
          } else {
            // 免息
            freeArray.push(tempInstallment[i].num)
          }
        }
      }
      // 描述信息
      let des = ''
      if (freeArray.length > 0) {
        des = '尾款阶段支持' + freeArray.join('、') + '期花呗免息分期'
      } else if (comArray.length > 0) {
        des = '尾款阶段支持' + comArray.join('、') + '期花呗分期'
      }
      return des
    },
    // 悬浮条文案
    floatTips(state, getters, { route }) {
      let text = ''
      if (getters.discountType === 'deposit' && state.selectParams?.laser) {
        text = '流程：添加定制信息-去结算-提交订单-支付定金'
      } else if (getters.discountType === 'deposit' && getters.antInstallmentTips?.length) {
        text = getters.antInstallmentTips
      } else if (getters.extCode && getters.extCode != 5) {
        text = state.skuInfo?.commoditySkuButton?.floatMessage?.trim() || ''
        if (getters.isSeeOther && route.query.purchaseChannel != 1) {
          text += '查看一下推荐的商品吧'
        }
        // 移动特惠异常库存状态下，统一展示立即办理
        if (getters.isOperatorBuyType) {
          text = getters.operatorAct?.actCondition || ''
        }
      } else {
        text = state.skuInfo?.commoditySkuButton?.floatMessage?.trim() || ''
        // floatTips: 全款预售/会员优先购>移动专享
        if (getters.isOperatorBuyType) {
          // 全款预定状态下取commoditySkuButton?.floatMessage
          text = getters.isFullPayBuy ? (text || getters.operatorAct?.actCondition || '' ) : (getters.operatorAct?.actCondition || '')
        }
      }
      if (getters.discountType === 'group') {
        text = ''
      }
      if (getters.discountType === 'vip') {
        if (state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst?.tips) {
          text = state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst?.tips
        }
      }
      return text
    },
    // 通用埋点信息
    commonTrackData(state, getters, { route }) {
      // 0:正常页面;1:秒杀页面;2:抢购进行中-有氛围;3:抢购进行中-无氛围;4:抢购进行中-共存;5:定金预售;6:全款预定;7:常规拼购;8:会员优先购;9:大促氛围;10:抢购预热;11:一分团;12:定金预售预热;13:全款预定预热
      let pageType = 0
      const { discountType, skuId, commodityEstimated, isAtmosphere, isQuickBuy, isGroup, isLottery } = getters
      if (discountType === 'seckill') {
        pageType = 1
      } else if (isQuickBuy) {
        if (isAtmosphere) {
          pageType = 2
        } else {
          // 无氛围抢购，判断是否有预热
          const commodityQuickBuyPreHeat =
            state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuyPreHeat
          if (commodityQuickBuyPreHeat) {
            if (commodityQuickBuyPreHeat.isAtmosphere) {
              pageType = 4
            } else {
              pageType = 10
            }
          } else {
            pageType = 3
          }
        }
      } else if (discountType === 'quickbuypreheat') {
        pageType = 10
      } else if (discountType === 'deposit') {
        // 1-进行中 2-待开始 0-其他
        const val = state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.state
        if (val === 2) {
          pageType = 12
        } else {
          pageType = 5
        }
      } else if (discountType === 'fullpay') {
        // 1-进行中 2-待开始 0-其他
        const val = state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityFullPay?.state
        if (val === 2) {
          pageType = 13
        } else {
          pageType = 6
        }
      } else if (isGroup) {
        pageType = isLottery ? 11 : 7
      } else if (discountType === 'vip') {
        pageType = 8
      } else if (discountType === 'bigpromotion') {
        pageType = 9
      }

      let deeplink
      const { from_deeplink } = route.query
      if (env.isVivoApp) {
        if (from_deeplink === 'true') {
          deeplink = 1
        } else {
          deeplink = 2
        }
      } else {
        deeplink = ''
      }

      return {
        page_name: 1,
        // 0:正常页面;1:秒杀页面;2:抢购进行中-有氛围;3:抢购进行中-无氛围;4:抢购进行中-共存;5:定金预售;6:全款预定;7:常规拼购;8:会员优先购;9:大促氛围;10:抢购预热
        // 无氛围活动进行中，有氛围活动预热中 --共存
        page_type: pageType,
        sku_id: skuId,
        // 实验ID TODO
        test_id: state?.spuInfo?.commodityDetailGrayTest?.testId,
        // 实验算法分类ID TODO
        plan_id: state?.spuInfo?.commodityDetailGrayTest?.testPlanId,
        // 是否有到手价(1:有到手价;2:无到手价)
        estimate_price: commodityEstimated?.commodityEstimatedPrice ? 1 : 2,
        // 是否来自deeplink唤起,vivoapp端正常商品详情页加载时必传,区分是否:deeplink唤起/vivoapp直接打开,非vivoapp端正常商品详情页参数传空值.(1:是,2:否)
        isno_deeplink: deeplink
      }
    },
    // 商品销售状态
    saleStatus(state, getters) {
      return !getters.extCode && !!state.skuInfo?.commoditySkuBaseInfo?.marketable
    },
    marketable(state, getters) {
      return !!state.skuInfo?.commoditySkuBaseInfo?.marketable
    },
    // 是否展示pk
    isShowPK(state, getters) {
      return (
        !getters.isGroup &&
        !getters.isVipFirstBuy &&
        state.skuInfo?.modelCompareFlag == 1 &&
        getters.isPhone &&
        getters.marketable
      )
    },
    isShowLogistics(state, getters) {
      const extCode = getters.extCode
      const isGift = getters.isGift == 1
      const hasExtCode = [1, 2, 3, 4].includes(extCode)
      // v986配件也显示物流时效
      const hasPhoneOrPj = [1, 2].includes(getters.goodsType)//虚拟商品为4，不显示送至模块
      // 拼团
      const isGroupon = getters.discountType === 'group'
      // 一分团
      const isLottery = getters.isLottery
      const re = hasPhoneOrPj && !getters.isYX && !hasExtCode && !isGift && !isGroupon && !isLottery
      return re
    },
    pointInfo(state) {
      return state.skuInfo?.commoditySkuDiscount?.commodityPoints
    },
    // 是否是预热阶段，true:是，false:不是
    isPreHot(state, getters) {
      const commoditySkuDiscountDetail = state.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail
      // 定金预售，全款预定，会员先享购
      return (
        commoditySkuDiscountDetail?.commodityDeposite?.state == 2 ||
        commoditySkuDiscountDetail?.commodityFullPay?.state == 2 ||
        commoditySkuDiscountDetail?.commodityVipFirst?.state == 2
      )
    },
    // 是否合并价格区域和标题区域: 没有积分抵现，没有订单满减活动，没有可用券，没有可领券,没有活动态，没有大促礼盒干预
    mergePriceAndTitle(state, getters) {
      let discountLabels = state.skuInfo?.commoditySkuDiscount?.discountLabels || []
      if(getters.isContractPhoneAndUnpublish) {
        discountLabels = discountLabels.filter(
          v => v.discountLabelType !== '6'
        )
      }
      return discountLabels.length == 0 && getters.discountType == 'normal'
    },
    // 支持前端生成海报图效果:  APP新版本 非IOS客户端  手机非拼团
    posterEnable(state, getters) {
      // 根据渠道判断 IOS客户端 或者 Andorid6及以下
      if (env.isIOSVivoApp || env.androidLevel <= 6) {
        return false
      }
      // 根据APP支持版本号判断
      if (env.isVivoApp && env.appVersion < 6750) {
        return false
      }
      return state.pageAllInit
    },
    // 分享相关接口请求参数中的channel字段
    shareQueryChannel(state, getters) {
      return getters.isLottery ? 'lottery' : getters.isGroup ? 'group' : getters.isVipFirstBuy ? 'vip' : 'normal'
    },
    isMoYin(state) {
      return state.spuInfo?.commoditySpu?.platformCode === '100023'
    },
    // 主图，如果选中套餐，则显示套餐主图
    mainImg(state, getters) {
      if (getters.currentSuiteInfo?.imageInfos?.length) {
        return getters.currentSuiteInfo.imageInfos[0].bigPic
      } else if (state.skuInfo?.imageInfos?.length) {
        return state.skuInfo.imageInfos[0].bigPic
      } else {
        return ''
      }
    },
    // todo 判断是否需要加载加购推荐
    hasAdditionRecommendList(state, getters) {
      return (
        state.spuInfo?.needRecommendFlag &&
        state.additionRecommendList.length > 0 &&
        !state.skuInfo.additionCommodityInfos?.length
      )
    },
    // todo 判断是否有加购推荐
    hasAdditionList(state, getters) {
      return state.additionCommodityInfo?.length > 0
    },
    // 型号
    modelName(state, getters) {
      return state.spuInfo?.commoditySpu?.modelName || ''
    },
    // 忽略曝光埋点
    ignoreShowTrack(state){
      return state.skuInfo?.skuSimpleChangeFlag
    }
  },
  actions: {
    ...buySubmodule.actions,
    ...recycle.actions,
    init({ dispatch, commit, state, getters }, params) {
      let isSend = true
      // 解决缓存数据颜色外显不显示的现象
      if (state.templateDataType == '1-1') {
        dispatch('setupInfos', { isSend })
        isSend = false
      }
      return Promise.all([dispatch('getSimpleSpu', params), dispatch('getSimpleSku', params)]).then(() => {
        commit('CHANGE_REGULATE', true)
        dispatch('setupInfos', { isSend })
        return Promise.all([dispatch('getDetailSpu', params), dispatch('getDetailSku', params)]).then(() => {
          // 页面初始化完成
          commit('CHANGE_PAGE_ALL_INIT', true)
          const addParams = {
            spuId: state.spuInfo?.commoditySpu?.id,
            skuId: state.skuInfo?.commoditySkuBaseInfo?.skuId,
            modelName: state.spuInfo?.commoditySpu?.modelName
          }
          // 更新SPU-异步移动合约机相关信息
          spuUpdate({
            spuInfo: state.spuInfo
          })
          // needRecommendFlag为true 且没有加价购活动的情况，需要调用 getAdditionRecommend
          if (!getters.hasAdditionList && state.spuInfo.needRecommendFlag) {
            dispatch('getAdditionRecommendSkus', addParams)
          }
        })
      })
    },
    setupInfos({ commit, state }, params) {
      let { isSend } = params
      commit('CHANGE_PAGE_INIT', true)
      skuInit({
        spuInfo: state.spuInfo,
        skuInfo: state.skuInfo,
        skuId: state.skuInfo.commoditySkuBaseInfo.skuId,
        buyType: state.selectParams.buyType,
        contractPhoneInitFlag: false
      })
      // 防止首屏数据上报后接口重复上报的场景
      if (!isSend) return
      try {
        // 此处用setTimeout时为了确保页面渲染完，因为执行渲染的过程是异步的
        window.VMonitor && window.VMonitor.rendered()
        // vvc_appclick 客户端点击商品存入cookie的时间戳
        const currentTime = new Date().getTime()
        // 优先取url里的时间戳，考虑页面刷新场景cookie值不更新
        const firstScreenDuration = currentTime - state.clickTime
        commit('CHANGE_LCP', firstScreenDuration)
        window.VMonitor?.report({
          ruleId: 'rWmBKsSq',
          business: '商城', // 用于区分不同业务
          href: location.href, // 页面链接
          initDuration: state.initDuration, // 点击到初始化时长
          firstScreenDuration: firstScreenDuration, // 点击到首屏时长
          isTemplate: state.isAPPTemplate, // 是否是离屏模板
          cookieId: getCookie('cookieId') || getCookie('vivo_fe_vftcookid'),
          isVivoSpace: env.isAndroid && env.isVivoApp, // 是否是官网app(安卓)
          appVersion: env.appVersion || '未知', // 官网版本
          androidLevel: env.androidLevel || '未知', // 安卓版本
          model: env.clientModel || '未知', // vivo机型
          source: getParameter('push_id') ? 1 : 0, // 来源
          featureId: state.templateDataType, // 离屏渲染类型：1：骨架屏，1-1：首屏，1-2：banner图
          zeusEnv: firstScreenDuration > 0 && firstScreenDuration < 10000 ? 'prod' : 'test'
        })
      } catch (e) {}
    },
    // 刷新页面
    refresh({ dispatch, commit, getters, state }) {
      const { skuId, spuId, isQuickBuy, discountType } = getters
      const { selectParams } = state
      const isForce = true
      let commonBuyParams = { skuId, spuId, channel: discountType, isForce }
      if(selectParams.buyType == 3) {
        commonBuyParams.buyType = 3
      }
      if (isQuickBuy) {
        dispatch('quickBuySubmit', { isEndCheck: true })
      } else {
        if(discountType == 'vip') {
          commit('UPDATE_VIP_FIRST_BUY_DISABLE',false)
        }
        dispatch('getSimpleSku', commonBuyParams)
        dispatch('getDetailSku', { skuId, spuId, channel: discountType, isForce })
      }
    },
    async getSimpleSpu({ commit, dispatch, state }, params) {
      try {
        const data = await getSimpleSpuReq(params)
        const goodsType = data?.commoditySpu?.cmmdyTypeId
        // 如果是配件，有两个规格，且第一个规格时颜色，则将颜色和第一规格项互换，确保颜色不在第一规格项
        const specMain = data?.specItem?.specMain
        const specMainSeq = data?.specItem?.specMainSeq
        if (goodsType == 2 && specMain?.length == 2 && specMainSeq[specMain[0]] === '颜色') {
          specMain.unshift(specMain.splice(1, 1)[0])
        }
        console.log(data.configInfoVo?.currentTime - new Date().getTime())
        commit('SET_SPU_INFO', data)
        // 获取是否收藏集合
        dispatch('listMemberFavorite')
        // 处理加购模块AB实验
        if (data.additionLocation) {
          commit('SET_ADDITION_LOCATION', data.additionLocation)
        }
      } catch (e) {
        // 强制跳转
        if (e && e.code == 302 && e.data?.configInfoVo?.redirectSpuInfo) {
          const { redirectSpuId, redirectSkuId } = e.data.configInfoVo.redirectSpuInfo
          window.location.replace(`/wap/product/${redirectSpuId}?skuId=${redirectSkuId}`)
        }
      }
    },
    async getSimpleSku({ commit, dispatch, state, getters }, params) {
      const { isForce, showToast, ...others } = params
      // 从缓存读取
      const storeSkuSimpleData = !isForce && (others.buyType == 3 ? state.allSkuSimpleDataForYD[others.skuId] : state.allSkuSimpleData[others.skuId])
      // 如果强制刷新，则清除另一个购买方式对应sku的缓存，避免切换购买方式时，仍然走缓存
      if(isForce){
        commit('CLEAR_SKU_SIMPLE_STORE_DATA')
      }
      // 如果没有缓存，那么从接口读取
      let data = storeSkuSimpleData
      if (!data) {
        showToast && toggleClickable(true)
        try {
          data = await getSimpleSkuReq(others)
          const nowTime = new Date().getTime()
          const currentTime = data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.currentTime
          if(currentTime){
            commit('SET_SKU_CURRENT_TIME', currentTime)
            commit('SET_SKU_CURRENT_TIME_DISTANCE', currentTime - nowTime)
          }
        } catch (err) {}
        toggleClickable(false)
      } else {
        // 从无预热活动的sku切换缓存且预热的sku，需要更新系统时间
        commit('UPDATE_SKU_CURRENT_TIME')
      }
      // 商详页到手价样式适配代金券，新人价
      if (data?.commoditySkuDiscount?.commodityEstimated?.commodityEstimatedPrice) {
        let estimatedCouponList = data.commoditySkuDiscount.commodityEstimated?.commodityEstimatedCouponList
        if (estimatedCouponList?.length) {
          data.commoditySkuDiscount.commodityEstimated.couponMemberLevel =
            estimatedCouponList.findIndex(v => v.couponMemberType == 3) > -1
              ? '0'
              : Math.max(...estimatedCouponList.map(v => v.couponMemberLevel))
        } else {
          data.commoditySkuDiscount.commodityEstimated.couponMemberLevel = '1'
        }
      }
      data.skuSimpleChangeFlag = false
      // 更新当前数据
      commit('SET_SKU_INFO', data)
      // 切换skuInfo之后，清空记录的原装列表
      if (state.partAdaptedObject?.flag) {
        commit('UPDATE_PART_ADAPTED_OBJECT', {
          flag: false,
          list: []
        })
      }
      // 如果当前skuId与配件不适用，且存在原装配件
      if (getters.partAdaptedInfo?.partAdaptedToModelType == 4 && getters.partAdaptedInfo?.hasOriginalCmmdy) {
        dispatch('queryPartAdaptedList')
      }

      // 没有数据需要写入缓存
      !storeSkuSimpleData && (others.buyType == 3 ? commit('SET_ALL_SKU_SIMPLE_DATA_FOR_YD', data) : commit('SET_ALL_SKU_SIMPLE_DATA', data))
      // 判断活动是否结束
      const vipTips = data?.commoditySkuDiscount?.vipTips
      // 判断是否有特惠活动
      const contractPhoneTips = data?.commoditySkuDiscount?.contractPhoneTips
      const noContractPhone = contractPhoneTips || !data?.commoditySkuDiscount?.commodityEstimated?.contractPhoneAct
      // 有特惠活动但0库存并且不是入口sku - vip先享也要置灰
      const zeroStoreContractPhone = params.buyType == 3 && noContractPhone && state.pageInit
      // vipTips
      let vipTipsToastShow = false
      if (
        data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.storeFlag === 0 ||
        ((params.channel === 'group' || params.channel === 'lottery') &&
          !data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.promotionId)
      ) {
        dispatch('groupSubmit', {
          channel: params.channel
        })
        // } else if (data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuy?.storeFlag === 0) {
        //   dispatch('quickBuySubmit', {})
      } else if (
        data?.commoditySkuDiscount?.commodityDiscountType === 'vip' &&
        (data.commoditySkuDiscount.commoditySkuDiscountDetail?.commodityVipFirst?.storeFlag === 0 ||
          data?.commoditySkuBaseInfo?.marketable === 0 || zeroStoreContractPhone)
      ) {
        // 没有可售活动商品（库存0、下架,满足其一）会员优先购活动常规库存和活动库存是独立的，这里的库存是指活动库存
        // 以spu级别访问，无可售sku，弹窗提示
        // 以sku级别访问，sku不可售，弹窗提示
        // vipFirstBuyPopup({
        //   vipBuyStatus: 2,
        //   skuInfo: state.skuInfo,
        //   isTrackClick: data.commoditySkuDiscount.commoditySkuDiscountDetail?.commodityVipFirst?.storeFlag === 0
        // })
        commit('UPDATE_VIP_FIRST_BUY_DISABLE', true)
      } else if (
        params.channel === 'vip' &&
        vipTips &&
        !data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst
      ) {
        if( params.skuId != params.oldSkuId ){
          // 入参channel=vip、vipTips不为空且commodityVipFirst为空，则直接toast提示
          this.$toast({
            message: vipTips,
            // 官网设置
            sec: 1, //对应3.5秒
            // H5设置
            duration: 3500
          })
          vipTipsToastShow = true
        }
      } else if (
        data?.commoditySkuDiscount?.commodityDiscountType === 'deposit' &&
        data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.spotStatus == 1 &&
        data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.state != 2
      ) {
        // 适配现货购买
        dispatch('getSpotEstimatedPrice', { ...others, skuId: data.commoditySkuBaseInfo?.skuId })
      } else if (
        params.channel === 'vip' &&
        params.buyType == 3 &&
        getters.isOperatorBuyType &&
        !vipTips &&
        !noContractPhone &&
        !data?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst
      ) {
        // 切换sku 移动特惠方式+vip ，切换到支持移动特惠但不支持会员先享的商品，提示
        this.$toast({
          message: '暂无进行中会员先享购活动，可预定购买',
          // 官网设置
          sec: 1, //对应3.5秒
          // H5设置
          duration: 3500
        })
      }
      if (params.buyType == 3 && noContractPhone){
        if(state.pageInit){
          // 切换移动特惠，活动失效 or 无库存 --> 更新spuInfo的zeroStoreSkuIds和supportSkuIds
          const contractPhoneInfoVo = state.spuInfo.contractPhoneInfoVo || {}
          const { supportSkuIds, disabledSkuIds } = contractPhoneInfoVo
          const supportSkuIdIndex = supportSkuIds.indexOf(getters.skuId)

          if(supportSkuIdIndex > -1){
            let targetSkuIds = [...supportSkuIds]
            targetSkuIds.splice(supportSkuIdIndex, 1)
            commit('SET_SPU_INFO', {
              contractPhoneInfoVo: {
                ...contractPhoneInfoVo,
                disabledSkuIds: (disabledSkuIds || []).concat([getters.skuId]),
              }
            })
            // 更新SPU-异步移动合约机相关信息
            spuUpdate({
              spuInfo: state.spuInfo,
              buyType: isForce ? 1 : '' // isForce
            })
          }else{
            spuUpdate({
              buyType: isForce ? 1 : '' // isForce
            })
          }

        }
        if(contractPhoneTips && (!state.pageInit || isForce) && !vipTipsToastShow){
          // 页面请求时移动特惠进入但没有活动，则直接toast提示【优先判断viptips】
          this.$toast({
            message: contractPhoneTips,
            // 官网设置
            sec: 1, //对应3.5秒
            // H5设置
            duration: 3500
          })
        }
        // 强刷sku信息时触发异常将params置为立即购买
        if(isForce){
          const selectParams = JSON.parse(JSON.stringify(state.selectParams))
          selectParams.buyType = 1
          dispatch('updateSelectParams', selectParams)
        }

      }

      // 从非移动特惠切换到移动特惠，活动有效时，更新已选状态
      if(params.buyType == 3 && !getters.isOperatorBuyType && !noContractPhone){
        const selectParams = JSON.parse(JSON.stringify(state.selectParams))
        selectParams.buyType = 3
        dispatch('updateSelectParams', selectParams)
      }
    },
    async getSpotEstimatedPrice({ commit }, params) {
      const data = await getEstimatedPrice(params)
      if (data) {
        commit('SET_SPOT_ESTIMATED_PRICE', data)
      } else {
        commit('SET_SPOT_ESTIMATED_PRICE', '')
      }
    },
    async getDetailSpu({ commit }, params) {
      const data = await getDetailSpuReq(params)
      commit('SET_SPU_INFO', data)

      // 获取购物车数量
      // 初始化购物车数量
      let cartNum = getCookie('shop_cart_num') || 0
      commit('UPDATE_CAET_NUMBER', cartNum)
      //  设置是否渲染送至和门店闪送flag
      commit('UPDATE_SHOW_ADDRESS_FLAG', true)
    },
    async getDetailSku({ commit, state, getters, dispatch }, params) {
      // 获取机型
      const model = getMachineCode()
      // isForce 强制从接口获取
      let { isForce, skuId, ...others } = params
      skuId = skuId || getters.skuId
      const storeSkuDetailData = !isForce && (others.buyType == 3 ? state.allSkuDetailDataForYD[skuId] : state.allSkuDetailData[skuId])
      // 如果强制刷新，则清除sku的缓存，避免切换购买方式或者sku时，仍然走缓存
      if(isForce){
       commit('CLEAR_SKU_DETAIL_STORE_DATA')
      }
      const data = storeSkuDetailData || (await getDetailSkuReq({ ...others, skuId, model, ...state.cacheAddressData }))
      if (!params.isPre) {
        data.specItemColor = null
      }
      // 如果有勾选的加购商品，则清空
      if (getters.hasAdditionCommodity) {
        dispatch('resetAdditionCommodity')
      }
      // 处理加购商品,移动特惠不露出加价购
      if (data?.additionCommodityInfos && others.buyType != 3) {
        dispatch('initAdditionCommodityInfo', data.additionCommodityInfos)
      } else {
        dispatch('resetAdditionCommodityInfo')
      }
      data.skuDetailChangeFlag = false
      commit('SET_SKU_INFO', data)
      !storeSkuDetailData && (others.buyType == 3 ? commit('SET_ALL_SKU_DETAIL_DATA_FOR_YD', { ...data, id: skuId }):commit('SET_ALL_SKU_DETAIL_DATA', { ...data, id: skuId }))
      // 如果此时已渲染悬浮条，且悬浮条展示，在同一sku状态下不进行重设
      console.log(state.oneStopRecycleVisibility,params.oldSkuId,params.skuId)
      const reInitRecycle = !(state.oneStopRecycleVisibility && params.oldSkuId && params.oldSkuId == params.skuId)
      if(others.buyType != 3 && reInitRecycle){
        // 无以旧换新大卡时，仅配置悬浮条活动时，设置为展示悬浮条
        if (getters.hasTradeInAc) {
          const specialAct = state.skuInfo?.commodityActivities.filter(item => item.recommendStatus == 1)
          if (specialAct && specialAct.length > 0 && specialAct[0].actType == 1) {
            // commit('ONE_STOP_RECYCLE_VISIBILITY', false)
          } else {
            console.log('___________module true 1____________')
            commit('ONE_STOP_RECYCLE_VISIBILITY', true)
          }
        } else {
          console.log('___________module true 2____________')
          commit('ONE_STOP_RECYCLE_VISIBILITY', true)
        }
      }
    },
    // todo 获取推荐数据
    async getAdditionRecommendSkus({ commit, getters }, params) {
      params.modelName = getters.modelName
      const res = await getAdditionRecommend(params)
      res.recommendList.forEach(sku => {
        sku.savePrice = parseFloat((sku.marketPrice - sku.salePrice).toFixed(2))
      })
      commit('SET_ADDITION_RECOMMEND_LIST', res.recommendList)
    },
    async getInstallment({ commit, state, getters }) {
      const { skuId, totalPrice, discountType, depositTotalPrice } = getters
      const salePrice = discountType === 'deposit' ? depositTotalPrice : totalPrice
      let key = skuId + '-' + salePrice.toFixed(2)
      const storeInstallmentData = state.allInstallmentData[key]
      try {
        const data =
          storeInstallmentData ||
          (salePrice &&
            (await getInstallmentReq({
              skuId,
              skuName: state.skuInfo.commoditySkuBaseInfo.skuName,
              salePrice: salePrice.toFixed(2)
            })))
        commit('SET_INSTALLMENT', { key, data })
      } catch (err) {
        commit('SET_INSTALLMENT', { key, data: null })
      }
    },
    async getPointInfo({ commit, state, getters }) {
      const { skuId, mainPrice, isDepositBuy, commodityEstimated, currentSuiteInfo } = getters
      // 从缓存读取
      // 如果没有缓存，那么从接口读取
      let money = mainPrice
      if (currentSuiteInfo?.id) {
        money = currentSuiteInfo.totalPrice
      } else if (isDepositBuy) {
        money = commodityEstimated?.commodityEstimatedPrice || state.skuInfo.commoditySkuBaseInfo.salePrice
      }
      const data = await getPointInfoReq({
        skuId,
        money: money
      })
      if (data.pointsMoney === 0) {
        data.supportFlag = false
      }
      commit('SET_POINT_INFO', { data })
    },
    async getRecommend({ commit, state, getters, dispatch }, { spuId, skuId }) {
      const { goodsType } = getters
      let params = {
        typeId: goodsType,
        defaultSkuId: skuId,
        spuId
      }
      let data = state.recommendMap[skuId]
      if (!data) {
        data = await getRecommendReq(params)
        // A/B实验且(手机或自营配件)走AI推荐
        try {
          if (
            (goodsType == 1 || (goodsType == 2 && !getters.isProxySale)) &&
            data.sourceFlag &&
            app.checkVersion(8400)
          ) {
            const similarRecomms = data.similarRecomms // 页中推荐
            const similarMeddle = similarRecomms?.filter(item => item.recallSource == 6) // 筛选出人工推荐
            const recommendList = data.recommendList // 页尾推荐
            const meddle = recommendList?.filter(item => item.recallSource == 6) // 筛选出人工推荐
            // let AISkuIds = {
            //   oneSkuIds: [128122, 128111, 128118, 128103, 128077, 128070, 128063, 128037, 127959, 127950, 11837, 21140, 24244, 127975, 128119, 128113, 10655, 127926, 127770, 128079, 128125, 128123, 126113, 126114],
            //   twoSkuIds: [126409, 125955, 24401, 125415, 24400, 23459, 23449, 22985, 21291, 21071]
            // }
            await getAIData({
              meddle,
              skuId,
              goodsType
            }).then(async AIResult => {
              if (AIResult?.oneSkuIds && AIResult?.twoSkuIds) {
                // 优先查询30+10，接口会过滤掉下架、无库品，防止数量不够，数量太多又有接口性能限制
                let oneList = await getAIRecommend({ spuId, skuIds: AIResult.oneSkuIds })
                let twoList = await getAIRecommend({ spuId, skuIds: AIResult.twoSkuIds })
                // 18+2
                oneList = oneList?.recommendList?.slice(0, 18) || [] // 前18个坑位
                twoList = twoList?.recommendList?.slice(0, 2) || [] // 后2个坑位
                const AIRecommendList = oneList.concat(twoList)
                if (AIRecommendList?.length) {
                  let meddleAIList = meddle.concat(oneList).slice(0, 18) // 人工 + 18
                  let AIData = meddleAIList.concat(twoList) // 人工 + 18 + 2个数据
                  const len = AIData.length
                  if (len >= 4) {
                    // 整体合并的数据为奇数时
                    if (len % 2) {
                      // 人工+18 为奇数，删除掉最后一个，保证2列完整展示
                      if (meddleAIList.length % 2) {
                        meddleAIList.splice(-1, 1)
                        AIData = meddleAIList.concat(twoList)
                      } else {
                        AIData.splice(-1, 1)
                      }
                    }
                    let similarAIData = similarMeddle.concat(oneList).slice(0, 6) // 页中推荐
                    // 缓存推荐数据
                    const allData = {
                      similarRecomms: similarAIData,
                      recommendList: AIData,
                      modelVersion: AIResult.modelVersion
                    }
                    data = allData
                  }
                }
              }
            })
          }
        } catch (error) {
          console.error(error, 'error')
        }
        commit('SAVE_RECOMMEND', { skuId, data })
      }
      commit('SET_RECOMMEND_LIST', data)
    },
    async updateSelectParams({ commit, state }, params) {
      commit('UPDATE_SELECT_PAEAMS', params)
      if (!state.isShowSkuSelect) {
        setAriaLiveByIds(state.ariaLiveElIds, 'polite')
      }
    },
    // 获取商品评价信息
    async getRemarkList({ commit, state, getters }) {
      const params = {
        type: 3, // 2：评价列表页评价，3：商详页评价
        spuId: getters.spuId,
        sortOrder: 'hot' // 按热度排序,desc为按时间排序
      }
      const data = await getRemarkList(params)
      commit('SET_REMARKINFO', data)
      // 用于判断是否需要显示titlebar中的评价、评价气泡
      commit('SET_EVALUATION', data)
    },
    /**
     * 根据spuId获取已经收藏的skuid集合
     * @param {Object} params - 包含spuId属性.
     */
    async listMemberFavorite({ commit, state, getters }) {
      const { goodsType, spuId } = getters
      let param = {
        spuId,
        // 0 普通商品 4 服务商品
        goodsType: goodsType == 3 ? 4 : 0
      }
      // 获取已经收藏的skuid集合
      listMemberFavorite(param)
        .then(data => {
          commit('UPDATE_COLLECTED_DATA', (data && data.memberFavoriteSkuIds) || [])
        })
        .catch(() => {
          commit('UPDATE_COLLECTED_DATA', [])
        })
    },
    // 控制sku选择弹层的开关,position 用来判断发起位置,填充source
    // source##来源(1:已选模块;2:加入购物车;3:立即购买;4:领券购买;5:立即预约;6:一键拼团;7:立即秒杀;8:单独购买;9:镭雕;10:全款预定;11:定金预售, 新增20:一站式换新更新规格)&&
    showSkuSelect({ commit, state }, { isShow = false, params = {} }) {
      commit('SHOW_SKU_SELECT', isShow)
      if (!isShow) {
        // 为了解决单独购买时，弹层关闭source改变引起弹层价格闪动的问题
        setTimeout(() => {
          commit('SHOW_SKU_SELECT_PARAMS', params)
        }, 200)
      } else {
        commit('UPDATE_SKU_CURRENT_TIME')
        commit('SHOW_SKU_SELECT_PARAMS', params)
      }
    },
    changeDiscountPopupStatus({ commit }, payload) {
      commit('CHANGE_DISCOUNT_POPUP_STATUS', payload)
    },
    changePointDescriptionPopupStatus({ commit }, payload) {
      commit('CHANGE_POINT_DESCRIPTION_POPUP_STATUS', payload)
    },
    changeShopcartPopupStatus({ commit }, payload) {
      commit('CHANGE_SHOP_CART_POPUP_STATUS', payload)
    },
    savePreFocusElByEvent({ commit }, e) {
      let target = null
      if (e.currentTarget?.id) {
        target = e.currentTarget.id
      } else {
        target = new Date().getTime().toString()
        e.currentTarget.setAttribute('id', target)
      }
      commit('SET_PREFOCUSEl', target)
    },
    changeInstallmentPopupStatus({ commit }, payload) {
      commit('CHANGE_INSTALLMENT_POPUP_STATUS', payload)
    },
    fetchCartNumber({ commit }) {
      let cartNum = getCookie('shop_cart_num') || 0
      commit('UPDATE_CAET_NUMBER', cartNum)
    },
    queryPartAdaptedList({ state, getters, commit }) {
      // 若当前skuId已经请求过配件列表，不做二次请求
      if (state.partAdaptedObject.flag) {
        return
      }
      // 获取接口列表
      return new Promise((resolve, reject) => {
        getPartCmmdyList({
          modelName: state.partAdaptedObject.modelName,
          skuId: getters.skuId
        })
          .then(data => {
            commit('UPDATE_PART_ADAPTED_OBJECT', {
              flag: true,
              list: data
            })
            resolve(data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    // 获取分享配置信息
    async getSkuShareInfo({ state, getters, commit }) {
      let prevData = null
      // 如果当前购买方式是“移动用户特惠”
      if (getters.isOperatorBuyType) {
        prevData = state.skuContractShareInfoStore[getters.skuId]
      } else {
        prevData = state.skuShareInfoStore[getters.skuId]
      }
      if (prevData) {
        return prevData
      }
      let params = {
        skuId: getters.skuId,
        channel: getters.shareQueryChannel
      }
      // 合约机增加buyType入参
      if (getters.isOperatorBuyType) {
        params.buyType = 3
      }
      const data = await shareContent(params).catch(() => {})
      if (data) {
        // 如果当前购买方式是“移动用户特惠”
        if (getters.isOperatorBuyType) {
          commit('UPDATE_SKU_CONTRACT_SHARE_INFO_STORE', { key: getters.skuId, val: data })
        } else {
          commit('UPDATE_SKU_SHARE_INFO_STORE', { key: getters.skuId, val: data })
        }
        return data
      }
    },
    // 控制以旧换新活动弹层的开关
    showRecycleIframe({ commit, state, getters }, isShow = false) {
      if (isShow) {
        sessionStorage.setItem('product_recycle_obj', JSON.stringify(getters.productRecycleInfo))
      } else {
        // 清除缓存的表单信息
        sessionStorage.removeItem('recycle_formcode_result')
      }
      commit('SHOW_RECYCLE_IFRAME', isShow)
    },
    setRecycleIframeParams({ commit }, params) {
      commit('SET_RECYCLE_IFRAME_PARAMS', params)
    },
    // 处理加购商品数据
    initAdditionCommodityInfo({ commit, state, dispatch }, data) {
      const newData = JSON.parse(JSON.stringify(data)).filter(el => {
        return el.additionSkus.length > 0
      })
      // 按照省钱多少降序排列
      newData.forEach(element => {
        element.additionSkus.sort((a, b) => b.salePrice - b.activityPrice - (a.salePrice - a.activityPrice))
      })
      commit('INIT_ADDITION_COMMODITY_INFO', newData)
      // 初始化展示的加购商品（如果存在历史选择的加购商品，则展示历史选择的商品）
      let showList = []
      let selectedAdditionCommodity = []
      newData.forEach(element => {
        if (state.preSelectedAdditionCommodity.spuList.includes(element.spuId)) {
          let skuList = element.additionSkus.filter(el => {
            return state.preSelectedAdditionCommodity.skuList.includes(el.skuId)
          })
          let skuItem = {
            ...skuList[0],
            savePrice: formatNumber(skuList[0].salePrice - skuList[0].activityPrice),
            spuId: element.spuId,
            spuName: element.spuName
          }
          showList.push(skuItem)
          selectedAdditionCommodity.push(skuItem)
        } else {
          let skuItem = {
            ...element.additionSkus[0],
            savePrice: formatNumber(element.additionSkus[0].salePrice - element.additionSkus[0].activityPrice),
            spuId: element.spuId,
            spuName: element.spuName
          }
          showList.push(skuItem)
        }
      })
      commit('INIT_SHOW_ADDIT_COMM_INFO', showList)
      dispatch('addAdditionCommodity', selectedAdditionCommodity)
    },
    // 清空加购商品数据
    resetAdditionCommodityInfo({ commit }) {
      commit('INIT_ADDITION_COMMODITY_INFO', [])
      commit('INIT_SHOW_ADDIT_COMM_INFO', [])
    },
    // 选中加购商品（如果是相同spu的，直接替换）data可以为加购商品的数组，也可以为加购商品的对象
    addAdditionCommodity({ state, dispatch }, data) {
      const selectParams = JSON.parse(JSON.stringify(state.selectParams))
      if (Array.isArray(data)) {
        selectParams.additionCommodity = data
      } else {
        let flag = false
        selectParams.additionCommodity.forEach((el, index) => {
          if (el.spuId == data.spuId) {
            selectParams.additionCommodity[index] = { ...data }
            flag = true
          }
        })
        if (!flag) {
          selectParams.additionCommodity.push(data)
        }
      }
      dispatch('updateSelectParams', selectParams)
      dispatch('getInstallment')
    },
    // 移除加购商品
    removeAdditionCommodity({ state, dispatch }, data) {
      const selectParams = JSON.parse(JSON.stringify(state.selectParams))
      selectParams.additionCommodity = selectParams.additionCommodity.filter(el => {
        return el.skuId != data.skuId
      })
      dispatch('updateSelectParams', selectParams)
      dispatch('getInstallment')
    },
    // 重置选中的加购商品信息
    resetAdditionCommodity({ state, dispatch, commit }) {
      const selectParams = JSON.parse(JSON.stringify(state.selectParams))
      const preAdditionCommodity = selectParams.additionCommodity
      selectParams.additionCommodity = []
      dispatch('updateSelectParams', selectParams)
      dispatch('getInstallment')
      // 保存选择的加购商品信息
      commit('UPDATE_PRE_SELECTED_ADDITION_COMMODITY', preAdditionCommodity)
    },
    // 更新展示的加购商品信息
    updateShowAdditCommInfo({ commit }, data) {
      commit('UPDATE_SHOW_ADDIT_COMM_INFO', data)
    }
  },
  mutations: {
    ...recycle.mutations,
    SET_CARY_ANIM_POSITION(state, data){
      state.cartAnimPosition = data
    },
    CHANGE_QUERY(state, data) {
      state.spuQuery = data
    },
    CHANGE_DURATION(state, data) {
      state.clickTime = data.clickTime
      state.initDuration = data.duration
    },
    CHANGE_LCP(state, data) {
      state.firstScreenDuration = data
    },
    CHANGE_PAGE_INIT(state, data) {
      state.pageInit = data
    },
    CHANGE_PAGE_ALL_INIT(state, data) {
      state.pageAllInit = data
    },
    CHANGE_REGULATE(state, data) {
      state.isRegulate = data
    },
    SET_PREFOCUSEl(state, data) {
      state.preFocusEl.push(data)
    },
    REMOVE_PREFOCUSEl(state) {
      state.preFocusEl.pop()
    },
    SET_SPU_INFO(state, data) {
      state.spuInfo = Object.freeze(Object.assign({}, state.spuInfo, data))
    },
    SET_SKU_INFO(state, data) {
      state.skuInfo = Object.freeze(Object.assign({}, state.skuInfo, data))
    },
    SET_ALL_SKU_SIMPLE_DATA(state, data) {
      state.allSkuSimpleData = Object.freeze(
        Object.assign({}, state.allSkuSimpleData, { [data.commoditySkuBaseInfo.skuId]: data })
      )
    },
    SET_ALL_SKU_SIMPLE_DATA_FOR_YD(state, data) {
      state.allSkuSimpleDataForYD = Object.freeze(
        Object.assign({}, state.allSkuSimpleDataForYD, { [data.commoditySkuBaseInfo.skuId]: data })
      )
    },
    SET_ALL_SKU_DETAIL_DATA(state, data) {
      state.allSkuDetailData = Object.freeze(Object.assign({}, state.allSkuDetailData, { [data.id]: data }))
    },
    SET_ALL_SKU_DETAIL_DATA_FOR_YD(state, data) {
      state.allSkuDetailDataForYD = Object.freeze(Object.assign({}, state.allSkuDetailDataForYD, { [data.id]: data }))
    },
    CLEAR_SKU_SIMPLE_STORE_DATA(state){
      state.allSkuSimpleData = {}
      state.allSkuSimpleDataForYD = {}
    },
    CLEAR_SKU_DETAIL_STORE_DATA(state){
      state.allSkuDetailData = {}
      state.allSkuDetailDataForYD = {}
    },
    RESET_ALL_DATA(state, data) {
      state.pageInit = false
      state.allSkuSimpleData = {}
      state.allSkuDetailData = {}
      state.allInstallmentData = {}
      state.spuInfo = {}
      state.skuInfo = {}
      state.discountPopupStatus = false
      state.installmentPopupStatus = false
      state.pointDescriptionPopupStatus = false
      state.adpatedPopupShow = false
      state.partListPopupShow = false
    },
    SET_INSTALLMENT(state, { key, data }) {
      data = JSON.parse(JSON.stringify(data))
      // 先缓存
      if (!state.allInstallmentData[key]) {
        state.allInstallmentData[key] = data
      }
      // 没有分期直接返回
      state.installmentInit = true
      //需要判断是否存在花呗分期
      if (data && ( data.selfInstallment?.perInstallmentInfoList || data.hbInstallment?.perInstallmentInfoList )) {
        // 对花呗分期进行排序
        if (data.selfInstallment?.perInstallmentInfoList) {
          data.selfInstallment.perInstallmentInfoList.sort((a, b) => a.num - b.num)
        }
        if (data.hbInstallment?.perInstallmentInfoList) {
          data.hbInstallment?.perInstallmentInfoList.sort((a, b) => a.num - b.num)
        }
        let perInstallmentInfoList = []
        let currentType = 0 // 显示弹层对应的tab
        if (data.hbInstallment?.perInstallmentInfoList) {
          perInstallmentInfoList = data.hbInstallment.perInstallmentInfoList
          currentType = 1
        } else if (data.selfInstallment?.perInstallmentInfoList) {
          perInstallmentInfoList = data.selfInstallment.perInstallmentInfoList
          currentType = 2
        }
        // 最大免息
        const bestFreePay = perInstallmentInfoList.filter(v => v.userTotalFeePay === 0).pop()
        // 最大分期
        const bestChargePay = perInstallmentInfoList.filter(v => v.userTotalFeePay !== 0).pop()
        // 最优分期 判断是否有免息，如果没有则取最大的分期
        const optimal = bestFreePay || bestChargePay
        // 提供一个描述文案供其他地方方便使用
        const optimalText = `${optimal.num}期${bestFreePay ? '免息' : '分期'}`
        state.installment = Object.freeze({
          // 详细信息
          detail: data,
          currentType,
          // 最佳
          optimal,
          optimalText,
          isFree: Boolean(bestFreePay)
        })
        //仅存在银联分期
      } else if (data && data.unionPayInstallment && data.unionPayInstallment.bankInstallmentList) {
        // 提供一个描述文案供其他地方方便使用
        const optimalText = data.unionPayInstallment.bankInstallmentList[0].label
        state.installment = Object.freeze({
          // 详细信息
          detail: data,
          currentType: 3,
          optimalText,
          isFree: false
        })
      } else {
        state.installment = {}
      }
    },
    SET_POINT_INFO(state, { data }) {
      const skuInfo = JSON.parse(JSON.stringify(state.skuInfo))
      skuInfo.commoditySkuDiscount.commodityPoints = data
      state.skuInfo = skuInfo
    },
    // 缓存sku的推荐数据
    SAVE_RECOMMEND(state, { skuId, data }) {
      state.recommendMap[skuId] = data
    },
    SET_RECOMMEND_LIST(state, data) {
      state.recommendList = data
    },
    /**
     * 更新已经收藏的skuid集合
     */
    UPDATE_COLLECTED_DATA(state, data) {
      state.collectedSkuIds = data
    },
    SHOW_SKU_SELECT(state, data) {
      state.isShowSkuSelect = data
    },
    SHOW_SKU_SELECT_PARAMS(state, data) {
      state.skuSelectParams = data
    },
    // 更新已选信息
    UPDATE_SELECT_PAEAMS(state, data) {
      const checkedInfo = JSON.parse(JSON.stringify(data))
      // 如果没服务，则说明是sku变化，那么使用原有的选中服务
      if (!checkedInfo.service) {
        checkedInfo.service = JSON.parse(JSON.stringify(state.selectParams.service))
      }
      // 判断是否存在加购商品，若不存在，则代表触发该操作为其他选中操作，此时保留历史加购商品
      if (!checkedInfo.additionCommodity) {
        checkedInfo.additionCommodity = JSON.parse(JSON.stringify(state.selectParams.additionCommodity))
      }
      // 购买方式
      if(!checkedInfo.buyType){
        checkedInfo.buyType = state.selectParams.buyType || 1
      }
      state.selectParams = checkedInfo
    },

    // 更新是否含有评价信息
    SET_EVALUATION(state, data) {
      state.postPreviews = data
    },
    // 更新评价内容
    SET_REMARKINFO(state, data) {
      state.remarkInfo = Object.assign({}, data)
    },
    // 设置视频是否可以播放
    SET_VIDEO_CAN_PLAY_STATE(state, data) {
      state.isVideoCanPlay = data
    },
    // 设置视频是否在此时init
    SET_VIDEO_INIT_FLAG(state, flag) {
      state.videoInitFlag = flag
    },
    // 快速参团信息
    UPDATE_QUICKGROUPON_DATA(state, data) {
      state.quickGrouponInfo = data
    },
    // 更新快速参团展示获取隐藏状态
    UPDATE_QUICKGROUPON_VISIBILITY(state, flag) {
      state.quickGrouponVisibility = flag
    },
    CHANGE_DISCOUNT_POPUP_STATUS(state, flag) {
      state.discountPopupStatus = flag
    },
    CHANGE_POINT_DESCRIPTION_POPUP_STATUS(state, flag) {
      state.pointDescriptionPopupStatus = flag
    },
    CHANGE_SHOP_CART_POPUP_STATUS(state, flag) {
      state.shopcartPopupStatus = flag
    },
    UPDATE_CARTID(state, flag) {
      state.cartIdValue = flag
    },
    CHANGE_INSTALLMENT_POPUP_STATUS(state, flag) {
      state.installmentPopupStatus = flag
    },
    UPDATE_CAET_NUMBER(state, number) {
      state.cartNumber = parseInt(number)
    },
    UPDATE_ADDRESS_ID(state, id) {
      state.addressId = id
    },
    UPDATE_ADDRESS_DATA(state, data) {
      state.addressData = data
    },
    CHANGE_SUBMIT_STSTUS(state, data) {
      let flag, interval
      if (typeof data == 'object') {
        flag = data.flag
        interval = data.interval
      } else {
        flag = data
        interval = 2000
      }
      // 正在处理
      if (flag) {
        state.isSubmiting = flag
        toggleClickable(true)
      } else {
        setTimeout(() => {
          toggleClickable(false)
          state.isSubmiting = flag
        }, interval)
      }
    },
    UPDATE_GIFT_ID(state, idStr) {
      state.giftIds = idStr
    },
    UPDATE_GIFT_OPT(state, num) {
      state.giftOpt = num
    },
    // 更新每个skuId商品下勾选的可选赠品
    UPDATE_SELECTED_GIFT_IDS(state, { skuId, ids }) {
      let index = state.selectedGifts.findIndex(item => item.skuId == skuId)
      if (index > -1) {
        state.selectedGifts[index].giftsList = [...ids]
      } else {
        state.selectedGifts.push({
          skuId,
          giftsList: [...ids]
        })
      }
    },
    UPDATE_LAST_CHOOSED_GIFT_IDS(state) {
      state.lastChoosedGiftIds = state.giftIds
    },
    SET_LOGISTICS_MSG(state, data) {
      state.logisticsMsg = data
    },
    SET_POSITION(state, { longitude, latitude }) {
      state.longitude = longitude
      state.latitude = latitude
    },
    UPDATE_ADDRESS_NEW_FLAG(state, flag) {
      state.addressNewFlag = flag
    },
    SET_SPECITEM_INFO(state,specData){
      state.specInfo = specData
    },
    SET_SPOT_ESTIMATED_PRICE(state, data) {
      state.spotEstimatedPrice = data
    },
    UPDATE_VIP_FIRST_BUY_DISABLE(state, flag) {
      state.vipFirstBuyDisable = flag
    },
    CHANGE_ADAPTED_POPUP_SHOW(state, flag) {
      state.adpatedPopupShow = flag
    },
    UPDATE_ADD_PARAMS(state, flag) {
      state.addCartParams = flag
    },
    CHANGE_PART_LIST_POPUP_SHOW(state, flag) {
      state.partListPopupShow = flag
    },
    UPDATE_PART_ADAPTED_OBJECT(state, obj) {
      state.partAdaptedObject = obj
    },
    UPDATE_SKU_SHARE_INFO_STORE(state, { key, val }) {
      state.skuShareInfoStore = Object.freeze(Object.assign({}, state.skuShareInfoStore, { [key]: val }))
    },
    UPDATE_SKU_CONTRACT_SHARE_INFO_STORE(state, { key, val }) {
      state.skuContractShareInfoStore = Object.freeze(Object.assign({}, state.skuContractShareInfoStore, { [key]: val }))
    },
    UPDATE_SHOW_ADDRESS_FLAG(state, flag) {
      state.showAddressFlag = flag
    },
    SET_AUTO_SHARE(state, flag) {
      state.autoShareFlag = flag
    },
    SET_LBS(state, flag) {
      state.isLBS = flag
    },
    SET_RECYCLE_IFRAME_PARAMS(state, data) {
      state.recycleIframeParams = data
    },
    SHOW_RECYCLE_IFRAME(state, data) {
      state.isShowRecycleIframe = data
    },
    INIT_ADDITION_COMMODITY_INFO(state, data) {
      state.additionCommodityInfo = data
    },
    UPDATE_SHOW_ADDIT_COMM_INFO(state, data) {
      state.showAdditCommInfo.forEach((el, index) => {
        if (el.spuId == data.spuId && el.skuId != data.skuId) {
          state.showAdditCommInfo.splice(index, 1, data)
        }
      })
    },
    INIT_SHOW_ADDIT_COMM_INFO(state, data) {
      state.showAdditCommInfo = data
    },
    SET_ADDITION_LOCATION(state, data) {
      state.additionLocation = data
    },
    SET_ADDITION_RECOMMEND_LIST(state, data) {
      state.additionRecommendList = data
    },
    SET_IS_SHOW_REMARK_POPUP(state, data) {
      state.isShowRemarkPopup = data
    },
    UPDATE_PRE_SELECTED_ADDITION_COMMODITY(state, data) {
      let skuList = []
      let spuList = []
      data.forEach(el => {
        skuList.push(el.skuId)
        spuList.push(el.spuId)
      })
      state.preSelectedAdditionCommodity = { skuList, spuList }
    },
    SET_CACHE_ADDRESS_DATA(state, cacheData) {
      state.cacheAddressData = cacheData
    },
    SET_TEMPLATE_FLAG(state, data) {
      state.isAPPTemplate = data
    },
    SET_TEMPLATE_TYPE(state, data) {
      state.templateDataType = data
    },
    SET_SKU_CURRENT_TIME(state, time){
      state.skuCurrentTime = time
    },
    UPDATE_SKU_CURRENT_TIME(state){
      state.skuCurrentTime = new Date().getTime() + state.skuCurrentTimeDistance
    },
    SET_SKU_CURRENT_TIME_DISTANCE(state, time){
      state.skuCurrentTimeDistance = time
    }
  }
}
